import EditableFilename from "../../shared/EditableFilename";
import type { DocumentTableDataType } from "../../DocumentTableTypes";

type Props = {
  row: DocumentTableDataType;
};

export const FilenameCell = ({ row }: Props) => (
  <EditableFilename document={row.document} />
);
